/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "./src/components/layout.css";

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_API_KEY}>
      {element}
    </GoogleReCaptchaProvider>
  )
}

// Disable scroll restoration completely for hash links
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return false;
  }
  return true;
};

// Optimized scroll handler
const performHashScroll = (hash, immediate = false) => {
  const element = document.getElementById(hash);
  if (!element) return;

  const headerOffset = 100;
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: immediate ? 'auto' : 'auto'
  });
};

// Handle scroll after route update
export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    const hash = location.hash.slice(1);
    
    // Use requestAnimationFrame for optimal timing
    requestAnimationFrame(() => {
      performHashScroll(hash, true);
    });
  }
};

// Prevent initial scroll flash
export const onInitialClientRender = () => {
  if (window.location.hash) {
    const hash = window.location.hash.slice(1);
    
    // Scroll immediately on mount
    requestAnimationFrame(() => {
      performHashScroll(hash, true);
    });
  }
};